import { render, staticRenderFns } from "./modalEditarModulo.vue?vue&type=template&id=757df958&"
import script from "./modalEditarModulo.vue?vue&type=script&lang=js&"
export * from "./modalEditarModulo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports